import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import { useSelector } from 'react-redux';

import { AddScheduleButton } from 'features/Schedules/AddScheduleButton';
import { bem } from 'helpers/class-name';
import { IA_KEY } from 'helpers/ia-logic';
import { selectIaLogic, selectVenueByVenueId } from 'selectors/general';

import './ScheduleAddClassButton.scss';

const { block } = bem('schedule-add-class-button');

const messages = defineMessages({
  addClass: {
    id: 'yield-management.schedule-add-class-button.label',
    defaultMessage: 'Add class',
  },
});

const ScheduleAddClassButton = ({ startDate, venueId }) => {
  const { featureIsSupported } = useSelector(state => selectIaLogic(state, IA_KEY.MANAGE_CLASS_SCHEDULE, venueId));
  const { isMsInventoryVenue } = useSelector(state => selectVenueByVenueId(state, venueId));

  // The Classtivity scheduler permission makes MANAGE_CLASS_SCHEDULE pass for every venue, but the
  // schedule creation form only loads its data for MSI venues; integrated venues sync their classes.
  if (!featureIsSupported || !isMsInventoryVenue) {
    return null;
  }

  return <AddScheduleButton className={block()} message={messages.addClass} startDate={startDate} venueId={venueId} />;
};

ScheduleAddClassButton.propTypes = {
  startDate: PropTypes.instanceOf(Date),
  venueId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default ScheduleAddClassButton;
